<template>
    <component
        v-bind:is="svg"
        style="max-width: 800px" />
</template>

<script setup>
    import { computed } from "vue";
    import createRelatedLink1 from "./svgs/createRelatedLink1.vue";
    import createRelatedLink2 from "./svgs/createRelatedLink2.vue";
    import createRelatedPub1 from "./svgs/createRelatedPub1.vue";
    import createRelatedPub2 from "./svgs/createRelatedPub2.vue";
    import makeSuccessorLink1 from "./svgs/makeSuccessorLink1.vue";
    import makeSuccessorLink2 from "./svgs/makeSuccessorLink2.vue";
    import makeSuccessorPub1 from "./svgs/makeSuccessorPub1.vue";
    import makeSuccessorPub2 from "./svgs/makeSuccessorPub2.vue";
    import markAsChildLink1 from "./svgs/markAsChildLink1.vue";
    import markAsChildPub1 from "./svgs/markAsChildPub1.vue";
    import markRelatedLookupLink1 from "./svgs/markRelatedLookupLink1.vue";
    import markRelatedLookupLink2 from "./svgs/markRelatedLookupLink2.vue";
    import markRelatedLookupPub1 from "./svgs/markRelatedLookupPub1.vue";
    import markRelatedLookupPub2 from "./svgs/markRelatedLookupPub2.vue";
    import projectLookupLink1 from "./svgs/projectLookupLink1.vue";
    import projectLookupLink2 from "./svgs/projectLookupLink2.vue";
    import projectLookupPub1 from "./svgs/projectLookupPub1.vue";
    import projectLookupPub2 from "./svgs/projectLookupPub2.vue";
    import projectTableLink1 from "./svgs/projectTableLink1.vue";
    import projectTableLink2 from "./svgs/projectTableLink2.vue";
    import projectTablePub1 from "./svgs/projectTablePub1.vue";
    import projectTablePub2 from "./svgs/projectTablePub2.vue";
    import submitRelatedLink1 from "./svgs/submitRelatedLink1.vue";
    import submitRelatedLink2 from "./svgs/submitRelatedLink2.vue";
    import submitRelatedPub1 from "./svgs/submitRelatedPub1.vue";
    import submitRelatedPub2 from "./svgs/submitRelatedPub2.vue";

    const props = defineProps({
        svgName: { type: String, required: false, default: null }
    });

    const svg = computed(() => {
        switch (props.svgName) {
            case "createRelatedLink1":
                return createRelatedLink1;
            case "createRelatedLink2":
                return createRelatedLink2;
            case "createRelatedPub1":
                return createRelatedPub1;
            case "createRelatedPub2":
                return createRelatedPub2;
            case "makeSuccessorLink1":
                return makeSuccessorLink1;
            case "makeSuccessorLink2":
                return makeSuccessorLink2;
            case "makeSuccessorPub1":
                return makeSuccessorPub1;
            case "makeSuccessorPub2":
                return makeSuccessorPub2;
            case "markAsChildLink1":
                return markAsChildLink1;
            case "markAsChildPub1":
                return markAsChildPub1;
            case "markRelatedLookupLink1":
                return markRelatedLookupLink1;
            case "markRelatedLookupLink2":
                return markRelatedLookupLink2;
            case "markRelatedLookupPub1":
                return markRelatedLookupPub1;
            case "markRelatedLookupPub2":
                return markRelatedLookupPub2;
            case "projectLookupLink1":
                return projectLookupLink1;
            case "projectLookupLink2":
                return projectLookupLink2;
            case "projectLookupPub1":
                return projectLookupPub1;
            case "projectLookupPub2":
                return projectLookupPub2;
            case "projectTableLink1":
                return projectTableLink1;
            case "projectTableLink2":
                return projectTableLink2;
            case "projectTablePub1":
                return projectTablePub1;
            case "projectTablePub2":
                return projectTablePub2;
            case "submitRelatedLink1":
                return submitRelatedLink1;
            case "submitRelatedLink2":
                return submitRelatedLink2;
            case "submitRelatedPub1":
                return submitRelatedPub1;
            case "submitRelatedPub2":
                return submitRelatedPub2;
        }
        return null;
    });
</script>
